import { Record } from 'immutable';

export default class TimeReport extends Record({
  id: null,
  comment: null,
  createdAt: null,
  dates: null,
  periods: null,
  resource: undefined,
  dateAndKilometers: undefined,
}) {
}
